import i18next from 'i18n/i18n';
import { SidebarItemType } from 'types/sidebar';

const dashboardItemList: SidebarItemType[] = [
  {
    path: 'home',
    href: '/home',
    name: i18next.t('home.home'),
    isShow: true,
    children: [{ href: '/home/status-board', name: i18next.t('home.statusBoard') }],
  },
  {
    path: 'loto-status',
    href: '/loto-status/conclusion',
    name: i18next.t('status.lotoStatus'),
    isShow: true,
    children: [
      { href: '/loto-status/conclusion', name: i18next.t('conclusion.conclusionStatus') },
      { href: '/loto-status/longTerm', name: i18next.t('conclusion.oldLotoStatus') },
      { href: '/loto-status/action', name: i18next.t('attachment.attachmentStatus') },
      { href: '/loto-status/communication', name: i18next.t('communication.communicationStatus') },
    ],
  },
  {
    path: 'loto-management',
    href: '/loto-management/setting',
    name: i18next.t('lotoManagement.lotoManagement'),
    isShow: true,
    children: [
      {
        href: '/loto-management/permission',
        name: i18next.t('orderManagement.orderManagement')
      },
      {
        href: '/loto-management/setting',
        name: i18next.t('orderManagement.lotoSetting')
      },
      {
        href: '/loto-management/box',
        name: i18next.t('boxOpen.openManagement')
      },
      {
        href: '/loto-management/log',
        name: i18next.t('lotoLog.lotoLog')
      },
      {
        href: '/loto-management/permission-transfer',
        name: i18next.t('orderTransfer.orderTransfer')
      },
      {
        href: '/loto-management/permission-log',
        name: i18next.t('orderLog.orderLog')
      },
    ],
  },
  {
    path: 'devices',
    href: '/devices/device',
    name: i18next.t('device.deviceManagement'),
    isShow: true,
    children: [
      {
        href: '/devices/device',
        name: i18next.t('device.deviceManagement')
      },
      {
        href: '/devices/factory-position',
        name: i18next.t('device.factoryPosition')
      },
      {
        href: '/devices/area-position',
        name: i18next.t('device.areaPosition')
      },
      {
        href: '/devices/zone-position',
        name: i18next.t('device.zonePosition')
      },
      {
        href: '/devices/equipment-position',
        name: i18next.t('device.equipPosition')
      }
    ],
  },
  {
    path: 'lockers',
    href: '/lockers/locker',
    name: i18next.t('lock.lockManagement'),
    isShow: true,
    children: [
      {
        href: '/lockers/locker',
        name: i18next.t('lock.lockManagement')
      },
    ],
  },
  {
    path: 'admin',
    href: '/admin/user',
    name: i18next.t('user.userManagement'),
    isShow: true,
    children: [
      {
        href: '/admin/user',
        name: i18next.t('user.userManagement')
      },
      {
        href: '/admin/lock-permission',
        name: i18next.t('lockAuth.authManagement')
      },
      // {
      //   href: '/admin/shift',
      //   name: i18next.t('shift.shiftManagement')
      // },
    ],
  },
  {
    path: 'setting',
    href: '/setting',
    name: i18next.t('setting.setting'),
    isShow: true,
    children: [
      {
        href: '/setting',
        name: i18next.t('setting.setting')
      },
    ],
  },
  {
    path: 'mypage',
    href: '/mypage',
    name: i18next.t('myPage.myInfo'),
    isShow: false,
    children: [
      {
        href: '/mypage',
        name: i18next.t('myPage.myInfo')
      },
    ],
  },
];

export default dashboardItemList;
